export default {
    site_url: 'https://sessiondesign.ru',
    brand_logo: '/img/brand/logo-big.png',
};
